import { useTranslation } from 'services/hooks';
import moment from 'moment';

import './style.css';

export default function DatePicker({
	fromTo,
	onFromChange,
	onToChange,
	label,
	startDateName,
	endDateName,
	startDateDefaultValue,
	endDateDefaultValue,
	endDateRef,
	startDateRef,
	startDisabled = false,
	type = 'date',
	format = 'DD-MM-YYYY',
}) {
	const getTranslation = useTranslation();

	const TRANSLATION_KEY = 'input';

	const _handleOnChange = ({ target }, cb) => {
		const cbValue = target.value ? moment(target.value).format(format) : null;
		if (cb && typeof cb === 'function') cb(cbValue);
	};

	return (
		<div className="DatePicker">
			{label && <label>{label}</label>}
			<div className="DatePicker__wrapper">
				<input
					type={type}
					onInput={e => _handleOnChange(e, onFromChange)}
					name={startDateName}
					ref={startDateRef}
					defaultValue={startDateDefaultValue}
					disabled={startDisabled || false}
				/>
				{fromTo && (
					<>
						<div className="to">{getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_date_picker_to_field`)}</div>
						<input
							type={type}
							onInput={e => _handleOnChange(e, onToChange)}
							name={endDateName}
							ref={endDateRef}
							defaultValue={endDateDefaultValue}
						/>
					</>
				)}
			</div>
		</div>
	);
}
